import { useContext } from 'react'

import AppContext from '@/common/context/app.context'

const useStores = () => {
  const { info } = useContext(AppContext)

  const getStoreById = id => {
    return info?.stores?.find(store => store.id === id)
  }

  const getStoreNameById = id => {
    const store = getStoreById(id)
    return store?.name
  }

  return {
    getStoreById,
    getStoreNameById,
  }
}

export default useStores
